import { defineRule } from 'vee-validate';
import { required, email, min, max } from '@vee-validate/rules';

export default function setupVeeValidateRules() {
  defineRule('required', required);
  defineRule('email', email);
  defineRule('min', min);
  defineRule('max', max);
  defineRule('password-meter', (_: string, [valid]: [string]) => {
    return valid === 'true';
  });
  defineRule('no-whitespace', (value: string) => {
    return !/\s/.test(value);
  });
}
